/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import Vue from 'vue';
import NotificationList from './notificationList.js';
import { getAttach } from '../utils/dom.js';
import './notification.js';
import 'lodash/isFunction';
import 'tdesign-icons-vue';
import '../utils/render-tnode.js';
import '@babel/runtime/helpers/typeof';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import './props.js';
import '../config-provider/config-receiver.js';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';
import '../utils/mixins.js';
import './const.js';
import 'raf';
import 'lodash/isString';
import '../utils/easing.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var seed = 0;
var instanceMap = /* @__PURE__ */new Map();

var NotificationFunction = function NotificationFunction(options) {
  seed += 1;

  var hackOptions = _objectSpread({
    placement: "top-right",
    zIndex: 6e3,
    attach: "body",
    id: seed
  }, options);

  hackOptions.content = options.content ? options.content : "";
  var attachEl = getAttach(hackOptions.attach);

  if (!instanceMap.get(attachEl)) {
    instanceMap.set(attachEl, {});
  }

  var tmpInstance = instanceMap.get(attachEl)[hackOptions.placement];

  if (!tmpInstance) {
    var list = new NotificationList({
      propsData: {
        placement: hackOptions.placement
      }
    });
    list.add(hackOptions);
    list.$mount();
    instanceMap.get(attachEl)[hackOptions.placement] = list;
    attachEl.appendChild(list.$el);
    tmpInstance = instanceMap.get(attachEl)[hackOptions.placement];
  } else {
    tmpInstance.add(hackOptions);
  }

  return new Promise(function (resolve) {
    tmpInstance.$nextTick(function () {
      var list = tmpInstance.$children;
      resolve(list[list.length - 1]);
    });
  });
};

var showThemeNotification = function showThemeNotification(theme, options) {
  var hackOptions = _objectSpread(_objectSpread({}, options), {}, {
    theme: theme
  });

  return NotificationFunction(hackOptions);
};

var extraApi = {
  info: function info(options) {
    return showThemeNotification("info", options);
  },
  success: function success(options) {
    return showThemeNotification("success", options);
  },
  warning: function warning(options) {
    return showThemeNotification("warning", options);
  },
  error: function error(options) {
    return showThemeNotification("error", options);
  },
  close: function close(promise) {
    promise.then(function (instance) {
      return instance.close();
    });
  },
  closeAll: function closeAll() {
    instanceMap.forEach(function (attach) {
      Object.keys(attach).forEach(function (placement) {
        attach[placement].removeAll();
      });
    });
  }
};
var NotificationPlugin = showThemeNotification;
Object.keys(extraApi).forEach(function (funcName) {
  NotificationPlugin[funcName] = extraApi[funcName];
});

NotificationPlugin.install = function () {
  Vue.prototype.$notify = NotificationPlugin;
  Vue.prototype.$notification = NotificationPlugin;
};

var NotifyPlugin = NotificationPlugin;

export { NotificationPlugin, NotifyPlugin, NotifyPlugin as default };
//# sourceMappingURL=plugin.js.map
